import React from "react";
import { RouteObject, redirect } from "react-router";

export const IntegrationRoutes: RouteObject[] = [
  {
    path: "",
    async lazy() {
      const { IntegrationsTab } = await import(
        /* webpackChunkName: "orgs-cache-integrations-tab" */ "orgs/Configuration/IntegrationsTab"
      );
      return { element: <IntegrationsTab /> };
    },
    async loader(args) {
      const { integrationsLoader } = await import(
        /* webpackChunkName: "orgs-cache-integrations-loader" */ "src/router/loaders/orgs/Integrations"
      );
      return integrationsLoader()(args);
    },
  },
  {
    path: "connected",
    async lazy() {
      const { IntegrationsTab } = await import(
        /* webpackChunkName: "orgs-cache-integrations-tab-connected" */ "orgs/Configuration/IntegrationsTab"
      );
      return { element: <IntegrationsTab /> };
    },
    async loader(args) {
      const { integrationsLoader } = await import(
        /* webpackChunkName: "orgs-cache-integrations-loader-connected" */ "src/router/loaders/orgs/Integrations"
      );
      return integrationsLoader("connected")(args);
    },
  },
  {
    path: ":tokenKind",
    async lazy() {
      const { IntegrationPage } = await import(
        /* webpackChunkName: "orgs-cache-integration-page" */ "orgs/Configuration/IntegrationsTab/IntegrationPage"
      );
      return { element: <IntegrationPage /> };
    },
    async loader(args) {
      const { tokenLoader } = await import(
        /* webpackChunkName: "orgs-cache-token-loader" */ "src/router/loaders/orgs/Integrations"
      );
      return tokenLoader(args);
    },
    children: [
      {
        path: "users",
        async loader(args) {
          const { integrationsUsersLoader } = await import(
            /* webpackChunkName: "orgs-cache-integrations-users-loader" */ "src/router/loaders/orgs/Integrations"
          );
          return integrationsUsersLoader(args);
        },
        async lazy() {
          const { CrmUsersTabSwitcher } = await import(
            /* webpackChunkName: "orgs-cache-crm-users-tab-switcher" */ "orgs/Configuration/IntegrationsTab/IntegrationPage/CrmUsersTabSwitcher"
          );
          return { element: <CrmUsersTabSwitcher /> };
        },
        children: [
          {
            path: ":crmUserId/edit",
            async lazy() {
              const { EditCrmUser } = await import(
                /* webpackChunkName: "orgs-cache-edit-crm-user" */ "orgs/Configuration/IntegrationsTab/IntegrationPage/CrmUsersTab/EditCrmUser"
              );
              return { element: <EditCrmUser /> };
            },
          },
        ],
      },
      {
        path: "settings",
        async loader(args) {
          const { integrationSettingsLoader } = await import(
            /* webpackChunkName: "orgs-cache-integration-settings-loader" */ "src/router/loaders/orgs/Integrations"
          );
          return integrationSettingsLoader(args);
        },
        async lazy() {
          const { SettingsTabSwitcher } = await import(
            /* webpackChunkName: "orgs-cache-settings-tab-switcher" */ "orgs/Configuration/IntegrationsTab/IntegrationPage/SettingsTabSwitcher"
          );
          return { element: <SettingsTabSwitcher /> };
        },
      },
      {
        path: "errors",
        async loader(args) {
          const { integrationErrorsLoader } = await import(
            /* webpackChunkName: "orgs-cache-integration-errors-loader" */ "src/router/loaders/orgs/Integrations"
          );
          return integrationErrorsLoader(args);
        },
        async lazy() {
          const { ErrorsTabSwitcher } = await import(
            /* webpackChunkName: "orgs-cache-errors-tab-switcher" */ "orgs/Configuration/IntegrationsTab/IntegrationPage/ErrorsTabSwitcher"
          );
          return { element: <ErrorsTabSwitcher /> };
        },
      },
      {
        path: "details",
        async lazy() {
          const { DetailsSwitcher } = await import(
            /* webpackChunkName: "orgs-cache-details-switcher" */ "orgs/Configuration/IntegrationsTab/IntegrationPage/DetailsSwitcher"
          );
          return { element: <DetailsSwitcher /> };
        },
        children: [
          {
            path: "authorize",
            async lazy() {
              const { AuthorizeModalSwitcher } = await import(
                /* webpackChunkName: "orgs-cache-authorize-modal-switcher" */ "orgs/Configuration/IntegrationsTab/IntegrationPage/AuthorizeModalSwitcher"
              );
              return { element: <AuthorizeModalSwitcher /> };
            },
          },
          {
            path: "signup",
            async lazy() {
              const { SignupModalSwitcher } = await import(
                /* webpackChunkName: "orgs-cache-signup-modal-switcher" */ "orgs/Configuration/IntegrationsTab/IntegrationPage/SignupModalSwitcher"
              );
              return { element: <SignupModalSwitcher /> };
            },
          },
        ],
      },
      {
        path: "",
        loader: () => {
          return redirect("details");
        },
      },
    ],
  },
];
